import { type Reducer, type UnknownAction } from "@reduxjs/toolkit";
import {
  sparxsEditorCoreEditorReducer,
  type SparxsEditorCoreEditorState,
} from "@/store/app/sparxsEditorCoreEditorReducer";
import {
  sparxsEditorAuxiliaryPlaceholderReducer,
  type SparxsEditorAuxiliaryState,
} from "@/store/app/sparxsEditorAuxiliaryReducerPlaceholder";

export type SparxsEditorBranchState = SparxsEditorCoreEditorState &
  SparxsEditorAuxiliaryState;

let auxiliaryReducer:
  | Reducer<SparxsEditorAuxiliaryState>
  | typeof sparxsEditorAuxiliaryPlaceholderReducer =
  sparxsEditorAuxiliaryPlaceholderReducer;

export const setSparxsEditorAuxiliaryReducer = (
  next: Reducer<SparxsEditorAuxiliaryState>,
): void => {
  auxiliaryReducer = next;
};

const pickCore = (s: SparxsEditorBranchState): SparxsEditorCoreEditorState => ({
  sparxsList: s.sparxsList,
  sparxsBlueprintCache: s.sparxsBlueprintCache,
  sparx: s.sparx,
  sparxTeaser: s.sparxTeaser,
  sparxSession: s.sparxSession,
  sessionPreferences: s.sessionPreferences,
  selectedInputField: s.selectedInputField,
  activeSparx: s.activeSparx,
  sparxsSearchIndex: s.sparxsSearchIndex,
  sparxsBlueprintFetchFailures: s.sparxsBlueprintFetchFailures,
  blueprintLoadBoundary: s.blueprintLoadBoundary,
  editorEntryBlocked: s.editorEntryBlocked,
  catalogSearch: s.catalogSearch,
  sparxReactions: s.sparxReactions,
});

const pickAux = (s: SparxsEditorBranchState): SparxsEditorAuxiliaryState => ({
  conflict: s.conflict,
  formState: s.formState,
  sparxsEventHandler: s.sparxsEventHandler,
});

export const sparxsEditorEditorReducer: Reducer<SparxsEditorBranchState> = (
  state,
  action: UnknownAction,
) => {
  const base = state ?? {
    ...sparxsEditorCoreEditorReducer(undefined, action),
    ...sparxsEditorAuxiliaryPlaceholderReducer(undefined, action),
  };
  const core = sparxsEditorCoreEditorReducer(pickCore(base), action);
  const aux = auxiliaryReducer(pickAux(base), action);
  return { ...core, ...aux };
};
